<div class="profile-toolbar" [class.profile-toolbar--minimized]="isMinimized">

    <rpc-button class="profile-toolbar-back" [title]="'PROFILE_TOOLBAR.TITLES.BACK'" [iconSquareButton]="true"
        [iconName]="'left'" (clicked)="onNavigateBack()">
    </rpc-button>

    <div class="profile-toolbar-title rpc-title-font">
        {{ (isAdditionalProfile ? 'PROFILE_TOOLBAR.TITLES.CHILD_PROFILE' : 'PROFILE_TOOLBAR.TITLES.PROFILE') |
        translate}}
    </div>

    <rpc-button class="profile-toolbar-btn" [iconSquareButton]="true" [title]="'PROFILE_TOOLBAR.TITLES.EDIT'"
        [iconName]="'edit'" (clicked)="onEdit()">
    </rpc-button>

</div>